import React from "react";
import {Route, Switch} from "Core/router";
import {AppPageRoute} from "Core/App";
import {pages} from "./pages";
import AppsNotFoundPage from "Core/pages/error/appsNotFound";
import {getObject} from "Core/helpers/data";

const AppsSection = () => (
	<div id="apps-section">
		<Switch>
			{pages.map((page, idx) => AppPageRoute({
				key: idx,
				page,
				...getObject(page, 'routerOptions')
			}))}
			<Route path="/" component={AppsNotFoundPage} exact={false} />
		</Switch>
	</div>
);

export * from "./config";
export * from "./pages";
export default AppsSection;